import React, { memo } from 'react';

import { Spinner } from 'components/core';
import { SingleOrganization } from 'components/organization/single';
import { useProjectOrganizationId } from 'store/project';
import { useOrganizations } from 'store/organizations';
import { organizationModelToOrganizationOnView } from 'shared/domain/organization/mapping/toView';

const OrganizationGeneralData = (): React.ReactElement => {
  const organizationId = useProjectOrganizationId();
  const { organizationsMap, loading: loadingOrganizations } =
    useOrganizations();
  const organizationModel = organizationsMap.get(organizationId);
  const organizationOnView =
    organizationModel &&
    organizationModelToOrganizationOnView(organizationModel);

  if (loadingOrganizations || !organizationOnView) {
    return (
      <Spinner reason='OrganizationGeneralData loading || loadingOrganizations || !Organization' />
    );
  }

  return <SingleOrganization {...organizationOnView} />;
};

export const MemoOrganizationGeneralData = memo(OrganizationGeneralData);
